import { useLoggedOutSuppliersPageCurrentCategory } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { useLoggedOutSuppliersPageFilterKeysQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPageFilterKeysQueryParams";
import fetchSuppliersPageLayoutElements from "@faire/web-api--source/endpoints/www/api/layout/suppliers-page/post";
import { ISuppliersPageLayoutRequest } from "@faire/web-api--source/indigofair/data/ISuppliersPageLayoutRequest";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const useLoggedOutSuppliersLayoutElementResponse = () => {
  const categoryModel = useLoggedOutSuppliersPageCurrentCategory();
  const categoryPathIdentifier = categoryModel?.mostSpecificPathIdentifier;
  const { filterKeys } = useLoggedOutSuppliersPageFilterKeysQueryParams();

  return useQuery({
    queryKey: [categoryPathIdentifier, filterKeys],
    queryFn: async ({ signal }) =>
      await fetchSuppliersPageLayoutElements(
        ISuppliersPageLayoutRequest.build({
          path_identifier: categoryPathIdentifier ?? "",
          filter_keys: filterKeys,
        }),
        { signal }
      ),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
};
